import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { EligibilityViewComponent } from '../eligibility-view/eligibility-view.component';
import { EligibilityService } from '../../services/eligibility.service';
import { EnquiryDialogComponent } from '../../components/shared/enquiry-dialog/enquiry-dialog.component';

@Component({
  selector: 'app-eligibility-page',
  standalone: true,
  imports: [CommonModule, MatButtonModule, EligibilityViewComponent],
  templateUrl: './eligibility-page.component.html',
  styleUrl: './eligibility-page.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class EligibilityPageComponent {
  constructor(
    public eligibilityService: EligibilityService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.eligibilityService.loadConfig();
  }

  openEnquiryForm(): void {
    this.dialog.open(EnquiryDialogComponent, {
      panelClass: 'enquiry-dialog-panel',
      width: '640px',
      maxWidth: '95vw'
    });
  }
  applyNow(): void {
    this.eligibilityService.applyNow();
  }
}
